/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Component, ElementRef, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { ZIndexUtils } from 'primeng/utils';
import { ButtonModule } from 'primeng/button';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'well-route-popup-full',
  templateUrl: './route-popup-full.component.html',
  styleUrls: ['./route-popup-full.component.scss'],
  standalone: true,
  imports: [ButtonModule, CommonModule, RouterOutlet]
})
export class RoutePopupFullComponent implements OnDestroy, OnInit {
  constructor(private router: Router, private renderer: Renderer2, private elementRef: ElementRef) {
    this.renderer.addClass(document.body, 'popup-full-outlet');
  }

  public close(): void {
    this.router.navigate([{ outlets: { 'popup-full': null } }], {
      queryParamsHandling: 'merge',
    });
  }

  ngOnDestroy(): void {
    this.renderer.removeClass(document.body, 'popup-full-outlet');
  }

  ngOnInit(): void {
    ZIndexUtils.set('modal', this.elementRef.nativeElement, 1000);
  }
}
